/**
 * Parse a string into a natural number (NOT including 0)
 *
 * @example
 * import { Maths } from '@catawiki/runtime-toolkit'
 *
 * assert.strictEqual(Maths.parseNat('42'), 42)
 * assert.strictEqual(Maths.parseNat('123'), 123)
 * assert.strictEqual(Maths.parseNat('0'), 1)
 * assert.strictEqual(Maths.parseNat('-10'), 1)
 * assert.strictEqual(Maths.parseNat('foo'), 1)
 */
export const parseNat = (num = '1') => {
    const out = parseInt(num, 10);
    return isNaN(out) ? 1 : Math.max(out, 1);
};
/**
 * Calculates the backoff time for the given value, using the [exponential backoff formula](https://en.wikipedia.org/wiki/Exponential_backoff#Expected_backoff).
 *
 * @example
 * import { Maths } from '@catawiki/runtime-toolkit'
 *
 * assert.strictEqual(Maths.backOff(1), 0.5)
 * assert.strictEqual(Maths.backOff(2), 1.5)
 * assert.strictEqual(Maths.backOff(3), 3.5)
 * assert.strictEqual(Maths.backOff(4), 7.5)
 */
export const backOff = (value) => (2 ** value - 1) / 2;
